const LineWrapper: FC = ({ children }) => (
  <div className="relative flex items-center justify-center after:absolute after:left-0 after:top-1/2 after:h-px after:w-full after:bg-beerus">
    {children}
  </div>
);
export default LineWrapper;
